import { createFileRoute } from '@tanstack/react-router'

import { Authentication } from '@/rbac'
import { AvailablePageContent } from '@/routes/arc/status/available/-components/AvailablePageContent.tsx'

export const Route = createFileRoute('/arc/status/available')({
  component: AvailablePage,
})

function AvailablePage() {
  return (
    <Authentication failMode={'empty'} require={'arc:call:answer'}>
      <AvailablePageContent />
    </Authentication>
  )
}
